import { render } from "./MaterialPage.vue?vue&type=template&id=718656dc"
import script from "./MaterialPage.ts?vue&type=script&lang=js"
export * from "./MaterialPage.ts?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__